import { FormControl, FormLabel, HStack, VStack } from '@chakra-ui/react';
import { CountrySelector } from '@jurnee/common/src/components/CountrySelector';
import { InputFormControl } from '@jurnee/common/src/components/InputFormControl';
import { AddressUpsertBody } from '@jurnee/common/src/dtos/address';
import { AddressJSON } from '@jurnee/common/src/entities/Address';
import { useTranslation } from 'react-i18next';

interface Props {
  address?: AddressUpsertBody;
  onChange(address: AddressUpsertBody): void;
}

export function AddressForm(props: Props) {
  const { t } = useTranslation('common');
  const address: AddressUpsertBody = props.address ?? {
    street: null,
    city: '',
    postalCode: null,
    state: null,
    country: '',
    countryCode: ''
  };

  function updateAddress(changes: Partial<AddressUpsertBody>) {
    props.onChange({ ...address, ...changes });
  }

  function onStreetChange(street: AddressJSON['street']) {
    updateAddress({ street });
  }

  function onCityChange(city: string) {
    updateAddress({ city });
  }

  function onPostalCodeChange(postalCode: AddressJSON['postalCode']) {
    updateAddress({ postalCode });
  }

  function onStateChange(state: AddressJSON['state']) {
    updateAddress({ state });
  }

  function onCountryChange(data: { label: string; value: string }) {
    updateAddress({
      country: data.label,
      countryCode: data.value
    });
  }

  return (
    <VStack w="100%" spacing={5}>
      <InputFormControl name="street" value={address.street} onChange={onStreetChange} isRequired />

      <HStack w="100%" spacing={5}>
        <InputFormControl name="city" value={address.city} onChange={onCityChange} isRequired />
        <InputFormControl name="postalCode" value={address.postalCode} onChange={onPostalCodeChange} isRequired />
      </HStack>

      <HStack w="100%" spacing={5}>
        <InputFormControl name="state" value={address.state} onChange={onStateChange} />

        <FormControl w="100%" id="country" isRequired>
          <FormLabel>{t('fields.country.label')}</FormLabel>
          <CountrySelector onChange={onCountryChange} value={address.countryCode} />
        </FormControl>
      </HStack>
    </VStack>
  );
}